import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect, useSelector, useDispatch } from "react-redux"
import { withRouter, Link, useHistory, useLocation } from "react-router-dom"

import { createBrand, updateCurrentBrand } from "store/brands/actions"
import { getPrimaryButtonClass, setCurrentBrandInLocalStorage } from "helpers/sf_utils"
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert"
import { logoutUser } from "store/actions"
import useQuery from "hooks/useQuery"
import useNewBrandUI from "hooks/useNewBrandUI"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menuBrands, setMenuBrands] = useState(false)
  const [menu, setMenu] = useState(false)

  const [user, setUser] = useState()
  const [brandList, setBrandList] = useState([])

  const [currentBrand, setCurrentBrand] = useState(false)
  const [nameInput, setNameInput] = useState('')

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const { current_user, brands, current_brand } = useSelector(state => ({
    current_user: state.Login.current_user,
    brands: state.Brands.brands,
    current_brand: state.Brands.current_brand,
  }));

  const show_rtb_brand_ui_changes = useNewBrandUI()

  const handleBrandCreate = (e) => {
    dispatch(createBrand(nameInput))
    setMenuBrands(!menuBrands);
    setNameInput('')

  }

  const query = useQuery();
  const brandIdFromUrl = query.get('brand_id')

  useEffect(() => {
    if (brandIdFromUrl && brands.length > 0) {
      const brandname = brands?.find(ele => ele?.id?.toString() === brandIdFromUrl?.toString())?.name
      setCurrentBrand({ id: brandIdFromUrl, name: brandname })
      setCurrentBrandInLocalStorage({ id: brandIdFromUrl, name: brandname })
    } else {
      setCurrentBrand(current_brand)
    }
  }, [brandIdFromUrl, brands, current_brand])

  const handleBrandChange = (e) => {
    if (currentBrand.id === e.target.id) {
      return
    }
    const brandname = brands.find(ele => ele.id.toString() === e.target.id.toString())?.name
    setCurrentBrand({ id: e.target.id, name: brandname })
    setMenuBrands(!menuBrands);

    // Update the URL with the new brand_id
    const newQuery = new URLSearchParams(query.toString());
    newQuery.set('brand_id', e.target.id);
    history.push({ search: newQuery.toString() });

    dispatch(updateCurrentBrand({
      brand: { id: e.target.id, name: brandname },
      history: { location: location.pathname, history: history }
    }));
    ToastAlert.fire({ icon: ToastAlertIconType.OK, title: "Switched to brand: " + brandname });
  };

  useEffect(() => {
    setUser(current_user)
  }, [dispatch])

  useEffect(() => {
    if (!brands) {
      return
    }
    const brand_list = brands && brands.map((e) => {
      return { label: e.name, value: e.id }
    })
    let blist = [...brandList]
    blist = brand_list
    setBrandList(blist)
  }, [brands])


  useEffect(() => {
    setUser(current_user)
  }, [current_user])

  const adminAccessLogout = () => {
    dispatch(logoutUser(history));
    localStorage.removeItem("adminAccess");
    window.close();
  }

  return (
    <React.Fragment>
      {brandList && brandList.length > 1 && !show_rtb_brand_ui_changes &&
        <Dropdown
          isOpen={menuBrands}
          toggle={() => setMenuBrands(!menuBrands)}
          className="d-inline-block"
        >
          <DropdownToggle
            className="btn header-item text-black"
            id="page-header-user-dropdown1"
            tag="button"
          >

            {currentBrand && ((brands.find(e => e.id.toString() === currentBrand?.id.toString())?.active === true) ?
              (currentBrand?.name) :
              (currentBrand?.name + "(disabled)"))}
            <span className="d-none d-xl-inline-block ms-2 me-1"></span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem header className="font-weight-semibold text-black">Brands</DropdownItem>
            <div className="dropdown-divider" />

            {
              brandList && brandList.map(e => {
                return (
                  <DropdownItem key={e.value}>
                    <div onClick={handleBrandChange}
                      id={e.value}
                      className={`e.label ${e.active ? "" : "text-black"} `}>
                      {e.label + (brands.find(ele => ele.id === e.value)?.active === true ? "" : "(disabled)")}
                    </div>
                  </DropdownItem>
                )
              })
            }

            {/* <DropdownItem> */}
            {
              <div hidden className="mx-2 mt-2">
                <Input
                  className="form-control w-lg"
                  type="text"
                  value={nameInput}
                  placeholder="Enter name"
                  onChange={(e) => { e.persist(); setNameInput(e.target.value); }}
                />
                <div className="ms-auto mt-2 float-end">
                  <button className={`btn ${getPrimaryButtonClass()} mx-1`} name="saveName"
                    onClick={handleBrandCreate}>Save</button>
                </div>
              </div>
            }
            {/* </DropdownItem> */}
          </DropdownMenu>
        </Dropdown>}

      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >

          <span className="d-none d-lg-inline-block ms-2 me-1 text-black">{user?.email}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          <i className="bx bx-user d-lg-none d-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <div className="dropdown-divider" />
          {
            (localStorage.getItem('adminAccess') && localStorage.getItem('authUser')) ?
              (<Link to="/logout" onClick={adminAccessLogout} className="dropdown-item">
                <i className="bx bx-undo font-size-16 align-middle me-1 text-danger" />
                <span>{props.t("Return to Original Account")}</span>
              </Link>) : (
                <Link to="/logout" className="dropdown-item">
                  <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
                  <span>{props.t("Logout")}</span>
                </Link>)
          }
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
